import 'reflect-metadata';
import 'zone.js';
import '@angular/localize/init';